import {get} from "@/utils/axios"

const getAddressList = p => get("/api-console/address/getAddressListByConfirm", p);

export default {
    getAddressList
}